import { FlightState, TypeFlight } from "@/lib/redux/features/flight/type"

export const byClass = (state: FlightState, flight: TypeFlight) => {
  const classes = state?.flightsResult?.filters?.classes || []
  if (classes?.length <= 0) {
    return true
  }
  return (flight?.inventories || [])?.some((inventory) => {
    return classes?.indexOf(inventory?.cabinClassType || '') > -1
  })
}